import { render, staticRenderFns } from "./CharityEditView.vue?vue&type=template&id=47f6039a&scoped=true"
import script from "./CharityEditView.vue?vue&type=script&lang=js"
export * from "./CharityEditView.vue?vue&type=script&lang=js"
import style0 from "./CharityEditView.vue?vue&type=style&index=0&id=47f6039a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6039a",
  null
  
)

export default component.exports